"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AggregateData = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const FormScope_1 = require("./FormScope");
const lib_1 = require("./lib");
const defaultAggregator = (v) => v;
function AggregateData({ name: nameProp, removeOnUnmount, keepRegistered, children, aggregate = defaultAggregator, validate, parentId, }) {
    const scope = (0, FormScope_1.useFormScope)();
    const name = [scope, nameProp].filter(Boolean).join('.');
    const dispatch = (0, react_1.useContext)(lib_1.InternalFormDispatchContext);
    const pageId = (0, react_1.useContext)(lib_1.FormPageContext);
    const parent = (0, react_1.useContext)(lib_1.AggregateDataContext);
    const [fatal, setFatal] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        if (fatal) {
            console.error(`FATAL: ${fatal}`);
        }
    }, [fatal]);
    (0, react_1.useEffect)(() => {
        var _a;
        dispatch === null || dispatch === void 0 ? void 0 : dispatch('REGISTER_AGGREGATOR', {
            name,
            aggregate,
            validate,
            parent: (_a = parentId !== null && parentId !== void 0 ? parentId : parent === null || parent === void 0 ? void 0 : parent.name) !== null && _a !== void 0 ? _a : null,
            pageId,
        });
        if (!dispatch) {
            setFatal('AggregateData has to be contained by a <Form> component');
        }
    }, [
        dispatch,
        name,
        aggregate,
        validate,
        parent,
        pageId,
        removeOnUnmount,
        parentId,
    ]);
    (0, react_1.useEffect)(() => {
        return () => {
            if (keepRegistered) {
                return;
            }
            dispatch === null || dispatch === void 0 ? void 0 : dispatch(removeOnUnmount ? 'REMOVE_AGGREGATOR' : 'UNREGISTER_AGGREGATOR', name);
        };
    }, [dispatch, keepRegistered, name, removeOnUnmount]);
    const value = (0, react_1.useMemo)(() => ({
        name,
        keepRegistered: Boolean(keepRegistered),
    }), [name, keepRegistered]);
    if (fatal) {
        return (0, jsx_runtime_1.jsxs)("div", { children: ["FATAL: ", fatal] });
    }
    return ((0, jsx_runtime_1.jsx)(lib_1.AggregateDataContext.Provider, Object.assign({ value: value }, { children: children })));
}
exports.AggregateData = AggregateData;
